/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {FETCH_LEGAL_DOCS_DETAILS_REQUEST, FETCH_LEGAL_DOCS_DETAILS_FAILURE, FETCH_LEGAL_DOCS_DETAILS_SUCCESS} from "./LegalDocumentsTypes";

const initialState = {
  loading: false,
  legaldocuments: [],
  error: "",
};

const legalDocumentsDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEGAL_DOCS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_LEGAL_DOCS_DETAILS_SUCCESS:
      return {
        loading: false,
        legaldocuments: action.payload,
        error: "",
      };
    case FETCH_LEGAL_DOCS_DETAILS_FAILURE:
      return {
        loading: false,
        legaldocuments: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default legalDocumentsDetailsReducer;